var productQty = 0;
$("body").on("click", ".single_minus_plus", function(){
  var totalVal = 0;
  var qty = parseInt($(this).closest(".single_qty").find(".single_qty_qty").val());
  var totalPrice = parseFloat($(".box_price").text());
  if($(this).hasClass("minus")){
    qty = qty-1;
    if(qty < 0){
      qty = 0;
    }
    $(".single_minus_plus.plus").removeClass("no-active");
    $(".builder_add_btn").find("button").removeClass("active");
  }
  else{
    qty = qty+1;
  }
  $(this).closest(".single_qty").find(".single_qty_qty").val(qty);
  totalPrice = 0;
  $(".single_qty_qty").each(function(index) {
      var val = parseInt($(this).val());
      totalVal = val + totalVal;
      totalPrice = (parseInt($(this).attr("data-price"))*val) + totalPrice;
    });
    if($(this).hasClass("minus")){
      $(".pack_image").eq(totalVal).addClass("empty");
      $(".pack_image").eq(totalVal).html(' ');
    }
    else{
      var imgSrc = $(this).closest(".single_pro_detail").find(".single_pro_img").find("img").attr("src");
      $(".pack_image").eq(totalVal-1).removeClass("empty");
      $(".pack_image").eq(totalVal-1).append('<img src="'+imgSrc+'" />');
    }
    totalPrice  = parseFloat(totalPrice);
    $(".box_price").text(totalPrice);
    var buildBoxBtn = false;
    $(".build_box_btn button").each(function(index) {
      if($(this).hasClass("active")){
        buildBoxBtn = true
      }
    });
    if(buildBoxBtn){
      if(totalVal == productQty){
        $(".single_minus_plus.plus").addClass("no-active");
        $(".builder_add_btn button").addClass("active");
      }
      else{
        $(".single_minus_plus.plus").removeClass("no-active");
        $(".builder_add_btn button").removeClass("active");
      }
    }
    else{
      $(".cookies_builder_btn").addClass("fixed_btn");
    }
});

$("body").on("click", ".build_box_btn button", function(){
  $(".builder_add_btn button").removeClass("special_cookies");
  $("#cookies_box_form").find('.product_name_properties').remove();
  $(".single_qty_qty").val(0);
  $(".single_minus_plus.plus").removeClass("no-active");
  $(".builder_add_btn button").removeClass("active");
  productQty = parseInt($(this).attr("data-count"));
  var productPrice = $(this).closest(".cookies_box").find("p").text();
  $("build_box_btn").find("button").removeClass("active");
  $(this).addClass("active");
  $(".cookies_builder_btn").removeClass("fixed_btn");
  $(".pack-container__price").text(productPrice);
  $(".pack-container__title").text("Pack "+productQty);
  $(".cookies_builder_modal_master").show();
  $(".pack_images_master").html(' ');
  $(".cookies_box_pro_master").show();
  $(".cookies_builder_btn").show();
  for(var i =0; i<productQty; i++){
    $(".pack_images_master").append('<div class="pack_image empty"></div>');
  }
  if(productQty === 12){
    $(".pack_image").addClass("box_12");
  }
  else{
    $(".pack_image").removeClass("box_12");
  }
  $([document.documentElement, document.body]).animate({
        scrollTop: $(".cookis_builder_inner").offset().top-200
  }, 100);
  
});

$("body").on("click", ".builder_btn_close", function(){
  $(".builder_add_btn button").removeClass("special_cookies");
  $(".cookies_builder_modal_master").hide();
});
$("body").on("click", ".builder_add_btn button", function(){
  if($(this).hasClass("special_cookies")){
    $("#cookies_box_form").submit();
  }
  else{
    $(".single_qty_qty").each(function(index) {
      if(parseInt($(this).val()) > 0){
        var productName = $(this).closest(".cookie_pro_single").find("h3").text();
        $("#cookies_box_form").append('<input type="hidden" class="product_name_properties" name="properties['+productName+']" value="'+$(this).val()+'" />');
      }
    });
    var productId = parseInt($(".build_box_btn").find("button.active").attr("data-id"));
    $("#cookies_box_form").find("#product_id").val(productId);
    $("#cookies_box_form").submit();
  }
});

$("body").on("click", ".builder_btn", function(){
  var count = 1;
  $(".single_qty_qty").each(function(index) {
    if(parseInt($(this).val()) > 0){
      $("#simple_checkout").append('<input type="hidden" name="items['+count+'][quantity]" value="'+$(this).val()+'" />');
      $("#simple_checkout").append('<input type="hidden" name="items['+count+'][id]" value="'+$(this).attr("data-product")+'" />');
      count++;
    }
  });
  $("#simple_checkout").submit();
});

$(".custom_hero_button").click(function(e) {
  e.preventDefault();
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".cookies_box_builder").offset().top-100
    }, 1000);
});

$("body").on("click", ".special_cookies_order", function(){
  var productName = $(this).data("product-name");
  var productImage = $(this).data("product-image");
  var productPrice = $(this).data("product-price");
  var productId = $(this).data("product-id");
  $("#cookies_box_form").find(".product_name_properties").remove();
  $(".cookies_builder_modal_master").show();
  $(".pack_images_master").html('');
  for(var i =0; i<12; i++){
    $(".pack_images_master").append('<div class="pack_image empty"></div>');
  }
  $(".pack-container__price").text(productPrice);
  $(".pack-container__title").text(productName);
  $(".pack_image").addClass("box_12");
  $(".pack_image").removeClass("empty");
  $(".pack_image").append('<img src="'+productImage+'" />');
  $("#cookies_box_form").append('<input type="hidden" class="product_name_properties" name="properties['+productName+']" value="12" />');
  $("#cookies_box_form").find("#product_id").val(productId);
  $(".builder_add_btn button").addClass("active special_cookies");
});
  $("body").on("click", ".cart__checkout_custom", function(){
    window.location.href="/checkout";
  });